var base = require('settings/payment-method/redeem-coupon');

Vue.component('spark-redeem-coupon', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/payment-method/redeem-coupon.js